import React, { useEffect } from "react";
import { useSubtitle } from "@/lib/subtitle";
import { useTranslation } from "react-i18next";
import { usePlayer } from "@/lib/PlayerContext";
import Pusher from "pusher-js";

export interface SubtitleViewProps {
  pusher: Pusher | null;
  episodeId: string;
  onSubtitleChange?: (subtitles: string[]) => void;
}

const SubtitleView: React.FC<SubtitleViewProps> = ({
  pusher,
  episodeId,
  onSubtitleChange,
}) => {
  const { i18n } = useTranslation();
  const { fullScreen } = usePlayer();
  let { subtitles } = useSubtitle(pusher, episodeId);

  useEffect(() => {
    onSubtitleChange?.(subtitles);
  }, [subtitles, onSubtitleChange]);

  const containerClass = fullScreen
    ? "tw-h-full tw-w-full tw-overflow-y-scroll tw-overflow-x-hidden tw-hidden-scrollbar tw-pointer-events-none"
    : "tw-h-full tw-w-full tw-overflow-hidden tw-pointer-events-none";

  return (
    <div className={containerClass}>
      {subtitles.map((subtitle: string, index: number) => (
        <div
          key={`subtitle-${index}`}
          className={
            fullScreen
              ? "tw-text-center tw-animate-fade-up"
              : "tw-text-left tw-animate-fade-up"
          }
        >
          <span
            className={
              fullScreen
                ? "tw-inline-block tw-rounded tw-bg-black/50 tw-px-2 tw-py-1 tw-text-white tw-text-xl tw-leading-tight"
                : "tw-inline-block tw-rounded tw-bg-black/50 tw-px-2 tw-py-1 tw-text-white tw-text-lg tw-leading-tight tw-max-w-full tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis"
            }
            style={{
              textShadow: "0 0 4px rgba(0,0,0,0.9), 0 0 4px rgba(0,0,0,0.8)",
            }}
          >
            {subtitle}
          </span>
        </div>
      ))}
    </div>
  );
};

export default SubtitleView;
